export default {
  'validation.password.notMatch': {
    ko: '비밀번호가 같지 않습니다.',
    ja: 'パスワードが不正です。',
    en: 'The passwords are not match.',
    cn: '',
  },
  'validation.registered': {
    ko: '이미 등록된 정보입니다.',
    ja: '既に登録されている情報です。',
    en: 'This information has already been registered.',
    cn: '',
  },
  'validation.email': {
    ko: '이메일이 유효하지 않습니다.',
    ja: '有効なメールアドレスを入力してください。',
    en: 'The email address is invalid.',
    cn: '',
  },
  'validation.required': {
    ko: '필수 입력 항목입니다.',
    ja: '必須入力項目です。',
    en: 'This field is required.',
    cn: '',
  },
};
